import { ActionType as ProgramItemActionType, actionTypes as programItemsAT } from 'store/programItems';
import { actionTypes as viewAT } from 'store/view';
import { FavoritesActionType } from './favorites.actionCreators';
import {
	REQUEST_FAVORITES_DATA_FAILURE,
	REQUEST_FAVORITES_DATA_SUCCESS,
	REQUEST_FAVORITES_META_DATA_SUCCESS,
	REQUEST_SELECTED_FAVORITE_DATA_FAILURE,
	REQUEST_SELECTED_FAVORITE_DATA_SUCCESS,
} from './favorites.actionTypes';

export type MetaDataType = {
	type: string;
	externalId: string;
};

export type FavoriteItemType = {
	[field: string]: any;
	externalId: string;
	favoriteMeta: {
		externalId: string;
		isFavorite: boolean;
		type: string;
	};
};

export type FavoritesStateType = {
	count: number;
	countWithDynamicProducts: number;
	metaData: Array<MetaDataType>;
	toggleState: {
		[externalId: string]: MetaDataType;
	};
	byId: FavoriteItemType | null;
	byCluster: { [key: string]: Array<any> } | null;
	error: Object | null;
	removedItemsPipe: Array<any>;
};

export type RootStateType = {
	favorites: FavoritesStateType;
};

// Reducer
// ------------------------------------
export const initialState: FavoritesStateType = {
	count: -1,
	countWithDynamicProducts: -1,
	byId: null,
	byCluster: null,
	metaData: [],
	toggleState: {},
	removedItemsPipe: [],
	error: null,
};

export const DYNAMIC_PRODUCT_CLUSTER_TYPE = 'PRODUCT_DYNAMIC';

export default (state: FavoritesStateType = initialState, action: FavoritesActionType | ProgramItemActionType) => {
	switch (action.type) {
		case programItemsAT.REQUEST_TOGGLE_FAVORITE_SUCCESS:
			const { id, favorite } = action;
			const favoritesById = state.byId || {};
			const favoritesItem = favoritesById[id] || {};
			const updatedFavoriteState = {
				...state,
				toggleState: {
					...state.toggleState,
					[id]: !!favorite,
				},
				byId: {
					...favoritesById,
					[id]: {
						...favoritesItem,
						favorite,
						favoriteMeta: {
							...(favoritesItem.favoriteMeta || {}),
							isFavorite: !!action.favorite,
						},
					},
				},
			};

			if (
				action.favorite === false &&
				favoritesItem.externalId &&
				updatedFavoriteState.byCluster &&
				updatedFavoriteState.byCluster !== null
			) {
				delete updatedFavoriteState.toggleState[favoritesItem.externalId];
				Object.keys(updatedFavoriteState.byCluster).forEach((cluster: string) => {
					if (
						updatedFavoriteState.byCluster === null ||
						!Array.isArray(updatedFavoriteState.byCluster[cluster]) ||
						updatedFavoriteState.byCluster[cluster] === null
					) {
						return;
					}
					updatedFavoriteState.byCluster[cluster].forEach(
						({ externalId }: { externalId: string }, index: number) => {
							if (
								externalId === favoritesItem.externalId &&
								updatedFavoriteState.byCluster !== null &&
								Array.isArray(updatedFavoriteState.byCluster[cluster])
							) {
								updatedFavoriteState.byCluster[cluster].splice(index, 1);
							}
						}
					);
				});
				return updatedFavoriteState;
			}

			if (
				action.itemType === 'PRODUCT_DYNAMIC' &&
				action.favorite === true &&
				favoritesItem.externalId &&
				typeof action.itemType === 'string'
			) {
				if (!updatedFavoriteState.byCluster) {
					updatedFavoriteState.byCluster = {};
				}

				if (!updatedFavoriteState.byCluster.PRODUCT_DYNAMIC) {
					updatedFavoriteState.byCluster.PRODUCT_DYNAMIC = [];
				}

				if (updatedFavoriteState.byCluster) {
					updatedFavoriteState.byCluster.PRODUCT_DYNAMIC.push({
						externalId: action.id,
						favorite: true,
						contentType: 'PRODUCT_DYNAMIC',
						productId: action.id,
					});
				}

				return updatedFavoriteState;
			}

			return updatedFavoriteState;

		case viewAT.VIEW_ID_CHANGED as any:
			if (state.removedItemsPipe.length === 0) {
				return state;
			}

			/*
			 * Do flush the removed items pipe on view change
			 * but after the items are flushed inside programItems!
			 */
			return {
				...state,
				removedItemsPipe: [],
			};

		case REQUEST_FAVORITES_META_DATA_SUCCESS:
			return {
				...state,
				metaData: action.data,
				error: null,
			};
		case REQUEST_SELECTED_FAVORITE_DATA_SUCCESS:
			const selectedItem = action.item || {};

			return {
				...state,
				byId: {
					...state.byId,
					[selectedItem.externalId]: selectedItem,
				},
			};
		case REQUEST_FAVORITES_DATA_SUCCESS:
			let count = 0;
			let countWithDynamicProducts = 0;
			const toggleState = {};
			const byId = {};
			const byCluster = { ALL: [] };

			action.data.forEach((favoriteItem) => {
				countWithDynamicProducts++;
				byId[favoriteItem.externalId] = favoriteItem;
				toggleState[favoriteItem.externalId] = true;

				if (!byCluster[favoriteItem.contentType]) {
					byCluster[favoriteItem.contentType] = [];
				}

				byCluster[favoriteItem.contentType].push(byId[favoriteItem.externalId]);
				if (favoriteItem.contentType !== DYNAMIC_PRODUCT_CLUSTER_TYPE) {
					(byCluster.ALL as any[]).push(byId[favoriteItem.externalId] as any);
					count++;
				}
			});

			return {
				...state,
				toggleState,
				count,
				countWithDynamicProducts,
				byId,
				byCluster,
				error: null,
			};
		case REQUEST_FAVORITES_DATA_FAILURE:
		case REQUEST_SELECTED_FAVORITE_DATA_FAILURE:
			return {
				...state,
				error: action.error,
			};
		default:
			return state;
	}
};
